import Vue from "vue";
import Toast, { TYPE } from "vue-toastification";
import "vue-toastification/dist/index.css";

/**
 * NOTE: If you are using other transition them make sure to import it in `src/@core/scss/vue/libs/notification.scss` from it's source
 */

const options = {
	toastDefaults: {
		position: "top-right",
		// ToastOptions object for each type of toast
		[TYPE.ERROR]: {
			timeout: 2000,
			closeButton: false,
		},
		[TYPE.SUCCESS]: {
			timeout: 1000,
			hideProgressBar: true,
		},
		draggable: true,
		pauseOnHover: true,
	},
};

Vue.use(Toast, options);

